var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_725_185)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 10.5H28V19.6667H26.3333V12.1667H9.66667V23.8333H19.6667V25.5H8V10.5H9.66667ZM16.3333 13.8333H13V17.1667H16.3333V13.8333ZM11.3333 18.8333H18V22.1667H11.3333V18.8333ZM24.6667 13.8333H19.6667V15.5H24.6667V13.8333ZM19.6667 17.1667H24.6667V18.8333H19.6667V17.1667ZM22.1667 20.5H19.6667V22.1667H22.1667V20.5ZM25.5 25.5V28H23.8333V25.5H21.3333V23.8333H23.8333V21.3333H25.5V23.8333H28V25.5H25.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_185",
    x1: 4.83645,
    y1: 4.72732,
    x2: 38.2596,
    y2: 32.6211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14086D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLogo);
export default __webpack_public_path__ + "static/media/contactLogo.13e049f707aa253ca1497b07cc8e57b4.svg";
export { ForwardRef as ReactComponent };